import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { Link } from 'wouter';
import { preloadPath } from '../routes';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string;
  children: ReactNode;
};

/**
 * Internal link with client-side navigation. Starts downloading the target route's chunk
 * as soon as the visitor shows intent (pointer over, focus, touch), so navigation feels instant.
 */
export function AppLink({ href, children, onPointerEnter, onFocus, onTouchStart, ...rest }: Props) {
  const warm = () => preloadPath(href);
  return (
    <Link
      href={href}
      onPointerEnter={(e) => {
        warm();
        onPointerEnter?.(e);
      }}
      onFocus={(e) => {
        warm();
        onFocus?.(e);
      }}
      onTouchStart={(e) => {
        warm();
        onTouchStart?.(e);
      }}
      {...rest}
    >
      {children}
    </Link>
  );
}
